<app-select [control]="control"
            [disabled]="agGridParams.componentParams.disabled"
            [options]="agGridParams.componentParams.options"
            [textGetter]="agGridParams.componentParams.textGetter"
            [valueGetter]="agGridParams.componentParams.valueGetter"
            [disableSort]="true"></app-select>
